<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Recibo por Honorarios</span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <!--<v-btn v-if="this.$hasPermision('empleados.create')" dark color="#023145" width="140" class="float-right" @click="handleShowCreate">
                        Nuevo
                    </v-btn>-->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels focusable>
            <v-expansion-panel v-for="(item, i) in anios" :key="i">
              <v-expansion-panel-header
                ><h1>{{ item }}</h1></v-expansion-panel-header
              >
              <v-expansion-panel-content style="padding-top: 1%">
                <v-card v-for="recibo of recibos" v-bind:key="recibo.id">
                  <v-list>
                    <v-list-item-group
                      color="indigo"
                      v-if="recibo.anio == item"
                    >
                      <v-list-item>
                        <!-- <v-list-item-icon>
                          <v-icon v-if="recibo.estado == true"
                            >fas fa-unlock</v-icon
                          >
                          <v-icon v-if="recibo.estado == false"
                            >fas fa-lock</v-icon
                          >
                        </v-list-item-icon> -->

                        <v-list-item-content
                          @click="almacena(recibo)"
                          cols="10"
                        >
                          <v-list-item-title v-if="recibo.estado == true"
                            >{{
                              recibo.nombre_mes.toUpperCase()
                            }}
                            (ABIERTO)</v-list-item-title
                          >
                          <v-list-item-title v-if="recibo.estado == false"
                            >{{
                              recibo.nombre_mes.toUpperCase()
                            }}
                            (CERRADO)</v-list-item-title
                          >
                          <span
                            >{{ recibo.fecha_inicio }} 12:00:00 am -
                            {{ recibo.fecha_fin }} 11:59:59 pm</span
                          >
                        </v-list-item-content>
                        <v-col
                          cols="2"
                          class="pt-1"
                          v-if="recibo.estado == false"
                        >
                          <h2 style="float:right;">{{ recibo.monto_total }}</h2>
                          <!--<v-btn width="140" class="float-right" style="margin-right: 2%" @click="modalPagar(recibo.monto_total)">
                                                    Pagar
                                                </v-btn>-->
                        </v-col>
                        <v-col cols="2" class="pt-1" v-else>
                          <!--<v-btn disabled width="140" class="float-right" style="margin-right: 2%">
                                                    Pagar
                                                </v-btn>-->
                        </v-col>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </template>
    <pagar ref="Pagar"></pagar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../components/auth/OfficeLogin";
import ArrayTools from "../../helpers/ArrayTools";
import router from "@/router/index";
import Pagar from "../../components/planillas/Pagar";

export default {
  name: "TrabajadoresHonorarios",
  components: {
    //CreateUpdate,
    //Filters,
    OfficeLogin,
    Pagar,
  },
  data() {
    return {
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Recibo por Honorarios",
          disabled: true,
          href: "",
        },
      ],
      anios: [],
    };
  },
  computed: {
    ...mapState("honorarios", ["recibos"]),
  },
  methods: {
    ...mapActions("honorarios", ["getHonorarios"]),
    ...mapActions("honorarios", ["getItems"]),
    ...mapActions("honorarioDetalle", ["getItemsEmple"]),
    modalPagar(monto) {
      this.$refs.Pagar.showForm("Pagar Planilla", monto);
    },
    async getAllHonorarios() {
      await this.getHonorarios();
      let data = this.recibos;
      let anioIndica = null;
      for (let i = 0; i < data.length; i++) {
        let anio = data[i].anio;
        // console.log(anio);
        if (anio != anioIndica) {
          this.anios.push(anio);
          anioIndica = anio;
        }
      }
      // console.log(this.anios[0]);
    },
    async almacena(recibo) {
      localStorage.setItem("id_recibo", recibo.id);
      localStorage.setItem("nombre_mes_honorario", recibo.nombre_mes);
      localStorage.setItem("anio_honorario", recibo.anio);
      await this.getItemsEmple(recibo.id);
      router.push("/app/planillas/HonorarioDetalle");
      //localStorage.id_planilla = id;
    },
  },
  created() {
    this.getAllHonorarios();
  },
};
</script>

<style scoped></style>
